<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
  <div class="container-header-inner">
    <div class="row">
      <div class="col-12">
        <h1 class="title-default">Configurações da FCI</h1>
        <p class="welcome-message">
          <button mat-icon-button type="button" (click)="voltar()">
            <mat-icon>arrow_back</mat-icon>
          </button>
          Parâmetros da Ficha de Conteúdo de Importação.
        </p>
      </div>
    </div>

    @if (isLoading) {
      <div class="section-container">
        <app-loading-box height="30" width="220" marginTop="0"></app-loading-box>
        <app-loading-box height="56" width="100%" marginTop="16"></app-loading-box>
      </div>
    } @else {
      <form [formGroup]="form">
        <div class="section-container">
          <div class="row mt-3">
            <div class="col-12">
              <div class="toggle-content">
                <mat-slide-toggle
                  class="app-toggle-compact"
                  formControlName="isVincularFciNotaFiscal"
                  color="primary">
                  Vincular FCI na nota fiscal automaticamente
                </mat-slide-toggle>
                <span class="info-text">
                  Ao marcar Sim, o número FCI será inserido automaticamente nos itens das notas fiscais de saída dos produtos vinculados.
                </span>
              </div>
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-12">
              <app-alert-card type="info">
                Esta configuração é global por empresa e pode ser alterada a qualquer momento. Valor padrão: <b>Não</b>.
              </app-alert-card>
            </div>
          </div>
        </div>
      </form>
    }
  </div>
</div>

<app-footer-action
  [isLoadingSalvar]="isSaving"
  [isSalvarDisabled]="isLoading"
  (cancelar)="voltar()"
  (salvar)="salvar()"></app-footer-action>
